import { Box, Button, Callout, Flex, Spinner } from "@radix-ui/themes";
import { FC, useState } from "react";
import useSubmitFeedback from "../../hooks/useSubmitFeedback";
import FeedbackFormInput from "../FeedbackFormInput/FeedbackFormInput";
import i18next from "i18next";
import { timestamp } from "@/api/firebase/firebase.config";
import {
  ExclamationTriangleIcon,
  InfoCircledIcon,
} from "@radix-ui/react-icons";

const FeedbackForm: FC = (): JSX.Element => {
  const [feedback, setFeedback] = useState({
    userName: "",
    uid: "",
    type: "bug",
    details: "",
    userAgent: "",
    createdAt: null,
  });
  const { submitFeedback, loading, error, success } = useSubmitFeedback();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    await submitFeedback(feedback);
  };

  return (
    <Box>
      {error && (
        <Callout.Root color="red">
          <Callout.Icon>
            <ExclamationTriangleIcon />
          </Callout.Icon>
          <Callout.Text>
            {i18next.t("feedback.error")} {error}
          </Callout.Text>
        </Callout.Root>
      )}

      {success && (
        <Callout.Root>
          <Callout.Icon>
            <InfoCircledIcon />
          </Callout.Icon>
          <Callout.Text>{i18next.t("feedback.success")}</Callout.Text>
        </Callout.Root>
      )}

      {/* Form */}
      {!success && (
        <form onSubmit={handleSubmit}>
          <FeedbackFormInput feedback={feedback} setFeedback={setFeedback} />

          {/* Submit */}
          <Flex direction="row" justify="end" gap="1" mt="4">
            <Button
              variant="solid"
              size="3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {!loading ? (
                i18next.t("feedback.fields.button.label")
              ) : (
                <Spinner />
              )}
            </Button>
          </Flex>
        </form>
      )}
    </Box>
  );
};

export default FeedbackForm;
